import { formatDateTime } from 'utils/dates/date.utils';

/**
 * Renders the full CAP info detail for one FEMA version.
 *
 * @param {{ info: object, version: object, className?: string }} props - CAP info and version.
 * @returns {JSX.Element} The full CAP detail block.
 */
import { getCategoryDisplayLabel } from '../../AlertCreator/components/IpawsAlertFields/config/Ipaws.config';

const FemaFullDetail = ({ info, version, className = 'border rounded p-3' }) => (
  <div className={className}>
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
      <div className="fw-bold fs-6">{info.event || version.payload.msgType || 'Alert'}</div>
      <div className="small text-muted d-flex flex-wrap gap-3">
        {version.payload.identifier ? <span>CAP: {version.payload.identifier}</span> : null}
        {version.payload.status ? <span>Status: {version.payload.status}</span> : null}
        {version.payload.scope ? <span>Scope: {version.payload.scope}</span> : null}
      </div>
    </div>

    <div className="fw-semibold mb-2">{info.language ?? 'Language not specified'}</div>
    {info.headline ? <div className="mb-2 fw-semibold">{info.headline}</div> : null}

    {(info.category?.length ||
      info.urgency ||
      info.severity ||
      info.certainty ||
      info.eventCode?.length) && (
      <div className="d-flex flex-wrap gap-3 mb-2 small">
        {info.category?.length ? (
          <div>
            <strong>Category:</strong> {info.category.map(getCategoryDisplayLabel).join('; ')}
          </div>
        ) : null}
        {info.urgency ? (
          <div>
            <strong>Urgency:</strong> {info.urgency}
          </div>
        ) : null}
        {info.severity ? (
          <div>
            <strong>Severity:</strong> {info.severity}
          </div>
        ) : null}
        {info.certainty ? (
          <div>
            <strong>Certainty:</strong> {info.certainty}
          </div>
        ) : null}
        {info.eventCode?.length ? (
          <div>
            <strong>Codes:</strong>{' '}
            {info.eventCode.map((code) => code.value ?? code.valueName ?? code).join(', ')}
          </div>
        ) : null}
      </div>
    )}

    {info.expires ? (
      <div className="small mb-2">
        <strong>Expires:</strong> {formatDateTime(info.expires)}
      </div>
    ) : null}
    {info.description ? (
      <div className="mb-2">
        <div className="fw-semibold">Description</div>
        <div>{info.description}</div>
      </div>
    ) : null}
    {info.instruction ? (
      <div className="mb-2">
        <div className="fw-semibold">Protective action instructions</div>
        <div>{info.instruction}</div>
      </div>
    ) : null}
    {info.contact ? (
      <div className="small">
        <strong>Contact:</strong> {info.contact}
      </div>
    ) : null}
  </div>
);

export default FemaFullDetail;
